import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import { getLanguage } from 'core/i18n';

export const generateRoboLanguageParameter = () => `${getLanguage()}-${getReferenceCodeByCountry().toUpperCase()}`;
